export enum Position {
    OneToThree = "01-03",
    FourToTen = "04-10",
    ElevenToTwenty = "11-20",
    TwentyOneToFifty = "21-50",
    FiftyOneToHundred = "51-100",
    GreaterThanTwenty = ">20",
}

// region top table component types

// region payload

export type PayloadRankingEntity = [string, number];

export type RankingDistributionPayload = Record<Position, Record<string, [PayloadRankingEntity, PayloadRankingEntity]>>;

// endregion

// region single mode

export type RankingSingleModeEntity = {
    currentMonth: string;
    currentMonthNumberOfPositions: number;
    previousMount: string;
    previousMonthNumberOfPositions: number;
};

export type RankingDistributionSingleModeData = Record<Position, RankingSingleModeEntity>;

// endregion

// region compare mode

export enum RankingDistributionMetric {
    ByPosition,
    ByWebsite,
}

export type RankingCompareModeEntity = {
    name: string;
    color: string;
    isActive: boolean;
    data: Array<{
        key: string;
        y: number;
        change: number;
        percentageFromTotal: number;
    }>;
};

export type RankingDistributionCompareModeData = Array<RankingCompareModeEntity>;

// endregion

// endregion
